export default __webpack_public_path__ + "static/hero-bg1-tablet-fc73280a9e5e4ba9097a1352f98bfbda.jpg";